export default __webpack_public_path__ + "static/media/Members-documentation.f845e43b.md";